import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
import { SimpleListAdapter, TS_DropDown } from '@nu-art/thunderstorm-frontend/index';
import { findingViewSection_RenderMethodLabelMap, findingViewSection_TypeLabelMap, findingViewSectionTypes, sectionRenderMethods } from '@app/advisor-ui-shared';
import { DropDown_DefaultCaret } from '@app/styles/frontend/ui/consts';
const mandatoryProps_SectionRenderMethod = {
    adapter: SimpleListAdapter([...sectionRenderMethods], item => _jsx(_Fragment, { children: findingViewSection_RenderMethodLabelMap[item.item] })),
    caret: DropDown_DefaultCaret,
    placeholder: 'Select Section Render Method',
};
export const DropDown_SectionRenderMethod = TS_DropDown.prepare(mandatoryProps_SectionRenderMethod);
const mandatoryProps_FindingViewSectionType = {
    adapter: SimpleListAdapter([...findingViewSectionTypes], item => _jsx(_Fragment, { children: findingViewSection_TypeLabelMap[item.item] })),
    caret: DropDown_DefaultCaret,
    placeholder: 'Select Section Type',
};
export const DropDown_FindingViewSectionType = TS_DropDown.prepare(mandatoryProps_FindingViewSectionType);
//# sourceMappingURL=ui-components.js.map